import React, { useCallback } from 'react'
import { Text } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { isArray } from 'lodash-es'

interface FiltersFormCounterProps {
  minPrice: number;
  maxPrice: number;
}

const FiltersFormCounter = ({
  minPrice,
  maxPrice,
}: FiltersFormCounterProps) => {
  const { watch } = useFormContext()

  const formValues = watch() as any

  const sumFilters = useCallback(
    (acc: any, current: any) => {
      const [key, value] = current
      if (
        key === 'price' &&
        (parseInt(value[0], 0) !== minPrice ||
          parseInt(value[1], 0) !== maxPrice)
      ) {
        return acc + 1
      } else if (key !== 'price' && isArray(value)) {
        return acc + value.length
      } else {
        return acc
      }
    },
    [maxPrice, minPrice]
  )

  const newFiltersCount = Object.entries(formValues).reduce(sumFilters, 0)

  if (Boolean(newFiltersCount) && newFiltersCount > 0) {
    return <Text as="span" ml={1}>{`(${newFiltersCount})`}</Text>
  }

  return null
}

export default FiltersFormCounter
